import React from "react";
export default class AccountSummaryMessage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (<div className="account-summary-message" dangerouslySetInnerHTML={{__html:this.props.messageData.messageBody}}/>);
    }
};



// WEBPACK FOOTER //
// ./src/components/account/AccountSummaryMessage.js